import { BaseHubOptions } from "../../BaseHubOptions";

export class EntryNotificationHubOptions extends BaseHubOptions {
	name: string = "shop-entry-log";
	commonEventNames: string[] = ['ChannelUpdates']
}